// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Guideline } from './guideline';
import { ProductType } from './product-type';
import { ProductTypeConfig } from './product-type-config';
import { ProgramReview } from './program-review';
import { ProximityUser } from './proximity-user';
import { ReviewResolution } from './review-resolution';
import { ReviewResolutionEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramReviewFinding extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Guid FK carriedFromFinding */
  carriedFromFindingId?: string;
  /** String */
  evidenceJson?: string;
  /** String(250) */
  findingKey!: string;
  /** Guid FK guideline */
  guidelineId?: string;
  /** String */
  message!: string;
  /** Guid FK productTypeConfig */
  productTypeConfigId?: string;
  /** Guid FK productType */
  productTypeId?: string;
  /** Guid FK programReview */
  programReviewId!: string;
  /** String */
  resolutionReason?: string;
  /** Guid FK resolvedByUser */
  resolvedByUserId?: string;
  /** DateTimeOffset */
  resolvedTs?: Date;
  /** Enum FK reviewResolution */
  reviewResolutionId!: ReviewResolutionEnum;
  /** Binary */
  rowVersion!: any;
  /** FK carriedFromFindingId */
  carriedFromFinding!: ProgramReviewFinding;
  /** FK guidelineId */
  guideline!: Guideline;
  /** FK productTypeId */
  productType!: ProductType;
  /** FK productTypeConfigId */
  productTypeConfig!: ProductTypeConfig;
  /** FK programReviewId */
  programReview!: ProgramReview;
  /** FK resolvedByUserId */
  resolvedByUser!: ProximityUser;
  /** FK reviewResolutionId */
  reviewResolution!: ReviewResolution;
}

